import { TextField, Typography } from '@mui/material';
import { withStyles } from '@mui/styles';
import React from 'react';
import styles from './styles';
import classes from '*.module.css';
// import { useStyles } from './styles';

interface Props {
  field: any;
  label: string;
  required?: boolean;
  error?: string;
  value?: string;
  name: string;
  multiline?: boolean;
  rows?: number;
}

export function InputField(props: Props) {
  const { name, label, error, multiline, rows, field } = props;
  const defaultProps = {
    className: 'textField',
    InputLabelProps: {
      shrink: true,
      className: 'label',
    },
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    field.onChange(e.target.value);
  };
  return (
    <>
      <TextField
        sx={styles}
        variant="outlined"
        {...defaultProps}
        label={label}
        onChange={handleChange}
        InputLabelProps={{
          className: 'label',
        }}
        name={field.name}
        multiline={multiline}
        rows={rows}
        value={field.value}
        autoComplete={name}
        error={error !== undefined}
      />
      <Typography
        color="error"
        sx={{
          fontSize: 13,
          marginBottom: '24px',
        }}
      >
        {<p>{error && error}</p>}
      </Typography>
    </>
  );
}

export default InputField;
